import experience from "../img/slideshow/experience-doctor.jpg";
import local from "../img/slideshow/local-capital.jpg";
import outcomes from "../img/slideshow/outcomes.jpg";
import scaling from "../img/slideshow/scaling.jpg";
import vision from "../img/slideshow/vision.jpg";

export default[
    experience, local, outcomes, scaling, vision
];